t = require('views/internal/teacup-with-helpers')('member_large_avatar')

module.exports = t.renderable ({ avatarHash, fullName, username }) ->
  title = "#{ fullName } (#{ username })"
  t.img { src: [window.avatarDomain, avatarHash, 'original.png'].join('/'), alt: title, title }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_large_avatar.coffee